module.exports = __webpack_public_path__ + "bde472554a199e46d4471e66c044221c.svg";